import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 代理店-グループ一覧取得
export async function getSaleCompanyPublishPaymentExcels(id: string) {
  try {
    const path = "saleCompanyPublishPaymentExcels";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
